import { Field } from 'redux-form';

import { DatePicker, normalizeDate } from 'common/components/forms';
import { dateFormat } from 'common/helpers/dateHelper';

const ReservationDate = (props) => {
  const { settings } = props;
  const today = new Date();
  today.setHours(today.getHours() + settings.data.reservations.leadTimeInHours);
  today.setHours(today.getHours() - 24);
  const isValidDate = (current) =>
    current.isSameOrAfter(dateFormat(today, settings, 'isoDate'));

  return (
    <Field
      name="reservationDate"
      className="c7-form-label__reservation-date"
      component={DatePicker}
      label="Reservation Date"
      normalize={normalizeDate}
      isValidDate={isValidDate}
      required
    />
  );
};

export default ReservationDate;
